var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.25 22.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.4,0H2.85A2.87,2.87,0,0,0,0,2.86V20A2.86,2.86,0,0,0,2.85,22.8H28.4A2.86,2.86,0,0,0,31.25,20V2.86A2.87,2.87,0,0,0,28.4,0Zm.45,6.12V18.76L21.26,12.2l6-6.1,1.62-1.66ZM27.46,2.4,23.92,6.05,18.79,11.3h0a1.07,1.07,0,0,0-.19.18s0,0-.05.06l-1.08,1.12a2.19,2.19,0,0,1-1.56.65,2.21,2.21,0,0,1-1.57-.65L13,11.27a.08.08,0,0,0,0,0,1.14,1.14,0,0,0-.16-.15l0,0L7.66,5.82,4.32,2.4ZM2.4,18.66V5.75h0V3.88L4.26,5.77l6,6.17Zm9.54-5,.67.68a4.6,4.6,0,0,0,6.57,0l.41-.4,7.46,6.45h-23Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.08c6726deef5bcdb9b554ee2cfde4c2a.svg";
export { ForwardRef as ReactComponent };